import httpClientPresidents from '../api/httpClientPresidents';

export const getAllPresidents = async () => {
  const response = await httpClientPresidents.get('/api/cms/PresidentsManagement/GetAll');
  return response.data;
};

export const createPresident = async ({ fullName, termStartYear, termEndYear = null, biography = '', isActive = true, photo = null }) => {
  const formData = new FormData();
  if (fullName != null) formData.append('FullName', fullName);
  if (termStartYear != null) formData.append('TermStartYear', String(termStartYear));
  if (termEndYear != null) formData.append('TermEndYear', String(termEndYear));
  if (biography != null) formData.append('Biography', biography);
  if (isActive != null) formData.append('IsActive', String(isActive));
  if (photo instanceof File) formData.append('Photo', photo, photo.name);
  const response = await httpClientPresidents.post('/api/cms/PresidentsManagement/Create', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const updatePresident = async ({ id, fullName, termStartYear, termEndYear = null, biography = '', isActive = true }) => {
  const response = await httpClientPresidents.put('/api/cms/PresidentsManagement/Update', {
    id,
    fullName,
    termStartYear,
    termEndYear,
    biography,
    isActive,
  });
  return response.data;
};

export const deletePresident = async (id) => {
  const response = await httpClientPresidents.delete(`/api/cms/PresidentsManagement/Delete/${id}`);
  return response.data;
};

export const getPresidentById = async (id) => {
  const response = await httpClientPresidents.get(`/api/cms/PresidentsManagement/GetById/${id}`);
  return response.data;
};

export const reorderPresidents = async ({ pastPresidentIdsInOrder }) => {
  const response = await httpClientPresidents.post('/api/cms/PresidentsManagement/Reorder', {
    pastPresidentIdsInOrder,
  });
  return response.data;
};

export const uploadPresidentPhoto = async ({ pastPresidentId, file }) => {
  const formData = new FormData();
  formData.append('PastPresidentId', pastPresidentId);
  if (file instanceof File) formData.append('Photo', file, file.name);
  const response = await httpClientPresidents.post('/api/cms/PresidentsManagement/UploadPhoto', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export default {
  getAllPresidents,
  createPresident,
  updatePresident,
  deletePresident,
  getPresidentById,
  reorderPresidents,
  uploadPresidentPhoto,
};


